import Grid from '@mui/material/Grid';
import { Fragment } from 'react';
import Card from '/@/components/crop-monitoring/cards';
import Drawing from '/@/components/drawing';
import Spinner from '/@/components/spinner';
import { _ } from '/@/locale';
import useWindowSize from '/@/utils/hooks/window-size';
import Title from '/@/v3/components/title';

const CropMonitoringTable = ({ cropMonitorings, loading, filterCropMonitorings }) => {
    const windowWidth = useWindowSize().width;
    const isDesktopSm = windowWidth <= 1024 && windowWidth >= 900;
    const isMobile = windowWidth <= 900;

    const isUsingFilters = Object.values(filterCropMonitorings).some(Boolean);

    return (
        <Fragment>
            {cropMonitorings.length ? (
                <Grid
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        gap: 3,
                        ...(isDesktopSm && { gridTemplateColumns: '1fr 1fr' }),
                        ...(isMobile && { gridTemplateColumns: '1fr' }),
                    }}
                >
                    {cropMonitorings.map((card, i) => {
                        return <Card isMobile={isMobile} index={i + 1} cropMonitoring={card} key={card.id} />;
                    })}
                </Grid>
            ) : (
                <Grid
                    sx={{
                        py: 10,
                    }}
                >
                    {loading ? (
                        <Grid container justifyContent='center' item xs={12}>
                            <Spinner />
                        </Grid>
                    ) : isUsingFilters ? (
                        <Drawing
                            type='crop-monitoring-not-found'
                            title={
                                <Title size='md' bolder color='gray-light'>
                                    {_(
                                        'No se han encontrado resultados para esta búsqueda o combinación de filtros. ¡Inténtalo de nuevo!'
                                    )}
                                </Title>
                            }
                        />
                    ) : (
                        <Drawing
                            type='crop-monitoring-not-found'
                            title={
                                <Fragment>
                                    <Title size='md' bolder color='gray-light'>
                                        {_(
                                            'Todavía no es época de siembra, no vas a poder crear un nuevo seguimiento de lote aún'
                                        )}
                                    </Title>
                                </Fragment>
                            }
                        />
                    )}
                </Grid>
            )}
        </Fragment>
    );
};

export default CropMonitoringTable;
